import { jsx } from "react/jsx-runtime";
import { b as useDimensions, e as useBackground, B as Box } from "./Grid-CcQKdsgp.js";
const Skeleton = (props) => {
  var _a, _b, _c, _d;
  const { radius = 0, className = "", md, d, ...rest } = props;
  const dimension = useDimensions({ m: { ...rest }, md, d });
  const background = useBackground({
    m: {
      ...props,
      bg: (_a = props.bg) != null ? _a : "var(--colors-text-secondary-default)",
      bgSize: (_b = props.bgSize) != null ? _b : "cover",
      bgRepeat: (_c = props.bgRepeat) != null ? _c : "no-repeat",
      bgPosition: (_d = props.bgPosition) != null ? _d : "center"
    },
    md: { ...md },
    d: { ...d },
    hover: {
      m: {
        ...props.hover
      },
      md: { ...md == null ? void 0 : md.hover },
      d: { ...d == null ? void 0 : d.hover }
    }
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: `animate-pulse ${dimension.className} ${background.className} ${className}`,
      style: { borderRadius: radius, ...dimension.styles, ...background.style }
    }
  );
};
export {
  Skeleton as S
};
